import { ToastContainer } from "react-toastify";
import styled from "styled-components";
import "react-toastify/dist/ReactToastify.min.css";

export const Toast = styled(ToastContainer)`
  &.Toastify__toast-container {
    width: 400px;
  }
`;
